import { useContext, CSSProperties } from 'react';
import { RadioButton, Input } from '../components'
import { DataContext } from '../data/DataContext';
import { catEfectuarLevatamiento, catMovitoNoServicio } from '../data/MochaData';

const Step1 = () => {

    const { ReclamosInspeccionNI, setReclamosInspeccionNI, changeHandler } = useContext(DataContext);

    const changeRadio = (propierties: string, value: boolean) => {
        setReclamosInspeccionNI({ ...ReclamosInspeccionNI, [propierties]: value });
    }

    const lblStyle: CSSProperties = {        
        color: '#4D4D4D',
        display: 'block',
        textAlign: 'center',
        marginTop: '5px',
    }

    return (
        <>
            <div className='mt-20'>
                <div style={lblStyle}><span><strong>Datos del siniestro</strong></span></div>
                <div style={lblStyle}><span><strong>Póliza:</strong> {ReclamosInspeccionNI.policy}</span></div>
                <div style={lblStyle}><span><strong>Nombre del asegurado:</strong> {ReclamosInspeccionNI.insuredName}</span></div>
                <div style={lblStyle}><span><strong>Placa:</strong> {ReclamosInspeccionNI.plate}</span></div>
                <div style={lblStyle}><span><strong>Marca:</strong> {ReclamosInspeccionNI.brand}</span></div>
                <div style={lblStyle}><span><strong>Modelo:</strong> {ReclamosInspeccionNI.model}</span></div>
                <div style={lblStyle}><span><strong>Color:</strong> {ReclamosInspeccionNI.color}</span></div>
            </div>
            <RadioButton
                label='¿Se va a efectuar el levantamiento del accidente?*'
                field={'registration'}
                key={'registration'}
                value={ReclamosInspeccionNI.registration}
                onChange={changeRadio}
                catalog={catEfectuarLevatamiento}
            />

            {ReclamosInspeccionNI.registration === 'N' &&
                <RadioButton
                    label='¿Por qué motivo no se efecturá el servicio?*'
                    field={'reasonNotRegistered'}
                    key={'reasonNotRegistered'}
                    value={ReclamosInspeccionNI.reasonNotRegistered}
                    onChange={changeRadio}
                    catalog={catMovitoNoServicio}
                />
            }
            {ReclamosInspeccionNI.reasonNotRegistered === '4' && ReclamosInspeccionNI.registration === 'N' &&
                <Input
                    id='anotherReason'
                    field='anotherReason'
                    type='textarea'
                    label='Indique el motivo*'
                    value={ReclamosInspeccionNI.anotherReason}
                    onChange={changeHandler}
                    placeholder='Ingresar motivo'

                />
            }
        </>
    )
}

export { Step1 }